/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1RegisteredEtsyShops, createTKT1RegisteredEtsyShop, updateTKT1RegisteredEtsyShop, deleteTKT1RegisteredEtsyShop, getTKT1EtsyInfoPacks, getTKT1TrustedStories } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt, FaStickyNote } from 'react-icons/fa';
import IframeModal from '../components/IframeModal/IframeModal';
import Select from 'react-select';

class TKT1RegisteredEtsyShop extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 100,
    sortBy: 'MID',
    sortOrder: 1,
    search: '',
    status: '',
    ref_etsy_info_pack_mid: '',
    trusted_story_mid: '',
    shop_id: '',
    seller1_username: '',
    seller2_username: ''
  }

  initShowColumns = {
    MID: true,
    shop_name: true,
    trusted_story_mid: true,
    ref_etsy_info_pack_mid: true,
    shop_id: true,
    seller1_username: true,
    seller2_username: true,
    buyer_registration_date: true,
    seller_registration_date: true,
    status: true,
    created_at: true,
    updated_at: true,
    note: true
  }

  initColumnWidths = {
    stt: 60,
    MID: 120,
    shop_name: 200,
    trusted_story_mid: 180,
    ref_etsy_info_pack_mid: 180,
    shop_id: 150,
    seller1_username: 150,
    seller2_username: 150,
    buyer_registration_date: 180,
    seller_registration_date: 180,
    status: 120,
    created_at: 150,
    updated_at: 150,
    note: 200,
    actions: 100
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      columnWidths: this.initColumnWidths,
      loading: false,
      showConfigModal: false,
      showCreateModal: false,
      showEditModal: false,
      showViewModal: false,
      showIframeModal: false,
      showNoteModal: false,
      showDeleteModal: false,
      showTrustedStoryModal: false,
      iframeUrl: '',
      iframeTitle: '',
      selectedShop: null,
      selectedNoteData: null,
      selectedTrustedStoryData: null,
      selectedShopForTrustedStory: null,
      isEditMode: false,
      isResizing: false,
      resizingColumn: null,
      resizeStartX: null,
      resizeStartWidth: null,
      createFormData: {
        ref_etsy_info_pack_mid: '',
        trusted_story_mid: '',
        shop_id: '',
        seller1_username: '',
        seller2_username: '',
        metadata: {},
        note: '',
        status: 'active'
      },
      editFormData: {
        ref_etsy_info_pack_mid: '',
        trusted_story_mid: '',
        shop_id: '',
        seller1_username: '',
        seller2_username: '',
        metadata: {},
        note: '',
        status: 'active'
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Registered Etsy Shop';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    // Check if URL has any query parameters
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      // URL has query parameters - override localStorage
      const queryObject = queryString.parse(queryStringFromUrl);
      
      // Parse numeric values
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      // Load showColumns separately from view config
      const viewConfig = JSON.parse(localStorage.getItem('TKT1RegisteredEtsyShop_ViewConfig'));
      const columnWidths = JSON.parse(localStorage.getItem('TKT1RegisteredEtsyShop_ColumnWidths'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        },
        columnWidths: {
          ...this.initColumnWidths,
          ...(columnWidths || {})
        }
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1RegisteredEtsyShops(apiQuery);
        this.loadDropdownData();
      })
    } else {
      // No URL params - use localStorage
      var query = JSON.parse(localStorage.getItem('tkt1_registered_etsy_shop_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1RegisteredEtsyShop_ViewConfig'));
      var columnWidths = JSON.parse(localStorage.getItem('TKT1RegisteredEtsyShop_ColumnWidths'));
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1RegisteredEtsyShops(apiQuery);
          this.loadDropdownData();
        })
      } else {
        const initialQuery = { ...this.initQuery };

        this.setState({
          query: initialQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1RegisteredEtsyShops(apiQuery);
          this.loadDropdownData();
        })
      }
    }
    
    // Add mouse event listeners for column resizing
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  }

  componentWillUnmount() {
    // Remove mouse event listeners
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }

  loadDropdownData = async () => {
    try {
      // Load dropdown data
      const query = { currentPage: 1, itemsPerPage: 1000, sortBy: 'MID', sortOrder: 1 };
      const storyQuery = { currentPage: 1, itemsPerPage: 1000, sortBy: 'artist_name', sortOrder: 1 };
      
      await Promise.all([
        this.props.getTKT1EtsyInfoPacks(query),
        this.props.getTKT1TrustedStories(storyQuery)
      ]);
    } catch (error) {
      console.error('Error loading dropdown data:', error);
    }
  }

  getEtsyInfoPackOptions = () => {
    return this.props.etsyInfoPacks ? this.props.etsyInfoPacks.map((pack) => ({
      value: pack.MID,
      label: `${pack.MID} - ${pack.trusted_person_info?.full_name || 'N/A'}${pack.device_pack_location_id ? ` (${pack.device_pack_location_id})` : ''}`
    })) : [];
  }

  getTrustedStoryOptions = () => {
    return this.props.trustedStories ? this.props.trustedStories.map((story) => ({
      value: story.MID,
      label: `${story.MID} - ${story.artist_name || 'N/A'}${story.etsy_shop_name ? ` (${story.etsy_shop_name})` : ''}`
    })) : [];
  }

  loadData = () => {
    const apiQuery = this.prepareApiQuery(this.state.query);
    this.props.getTKT1RegisteredEtsyShops(apiQuery);
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleStatusChange = (e) => {
    const newQuery = { ...this.state.query, status: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_registered_etsy_shop_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1RegisteredEtsyShops(apiQuery);
  }

  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_registered_etsy_shop_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1RegisteredEtsyShops(apiQuery);
  }

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_registered_etsy_shop_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1RegisteredEtsyShops(apiQuery);
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      // Save view config to localStorage
      localStorage.setItem('TKT1RegisteredEtsyShop_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  // Column resizing handlers
  resetColumnWidths = () => {
    this.setState({ columnWidths: this.initColumnWidths });
    localStorage.removeItem('TKT1RegisteredEtsyShop_ColumnWidths');
  }

  handleMouseDown = (e, columnKey) => {
    e.preventDefault();
    e.stopPropagation();
    
    this.setState({
      isResizing: true,
      resizingColumn: columnKey,
      resizeStartX: e.clientX,
      resizeStartWidth: this.state.columnWidths[columnKey]
    });
    
    document.body.classList.add('table-resizing');
  }

  handleMouseMove = (e) => {
    if (!this.state.isResizing || !this.state.resizingColumn) return;
    
    e.preventDefault();
    const deltaX = e.clientX - this.state.resizeStartX;
    const newWidth = Math.max(50, this.state.resizeStartWidth + deltaX);
    const resizingColumn = this.state.resizingColumn;
    
    this.setState(prevState => ({
      columnWidths: {
        ...prevState.columnWidths,
        [resizingColumn]: newWidth
      }
    }));
  }

  handleMouseUp = () => {
    if (this.state.isResizing) {
      this.setState({
        isResizing: false,
        resizingColumn: null,
        resizeStartX: null,
        resizeStartWidth: null
      });
      
      document.body.classList.remove('table-resizing');
      
      // Save column widths to localStorage
      localStorage.setItem('TKT1RegisteredEtsyShop_ColumnWidths', JSON.stringify(this.state.columnWidths));
    }
  }

  // Map status to Vietnamese
  mapStatus = (status) => {
    if (!status) return '-';
    switch (status.toLowerCase()) {
      case 'active':
        return 'Hoạt động';
      case 'inactive':
        return 'Không hoạt động';
      case 'suspended':
        return 'Tạm dừng';
      case 'deleted':
        return 'Đã xóa';
      default:
        return status;
    }
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  // Modal handlers
  handleViewClick = (shop) => {
    this.setState({
      showViewModal: true,
      selectedShop: shop,
      isEditMode: false
    });
  }

  handleEditClick = (shop) => {
    this.setState({
      showEditModal: true,
      selectedShop: shop,
      isEditMode: true,
      editFormData: {
        ref_etsy_info_pack_mid: shop.ref_etsy_info_pack_mid || '',
        trusted_story_mid: shop.trusted_story_mid || '',
        shop_id: shop.shop_id || '',
        seller1_username: shop.seller1_username || '',
        seller2_username: shop.seller2_username || '',
        metadata: shop.metadata || {},
        note: shop.note || '',
        status: shop.status || 'active'
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedShop: null,
      isEditMode: false
    });
  }

  handleCloseCreateModal = () => {
    this.setState({
      showCreateModal: false,
      createFormData: {
        ref_etsy_info_pack_mid: '',
        trusted_story_mid: '',
        shop_id: '',
        seller1_username: '',
        seller2_username: '',
        metadata: {},
        note: '',
        status: 'active'
      }
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedShop: null,
      isEditMode: false,
      editFormData: {
        ref_etsy_info_pack_mid: '',
        trusted_story_mid: '',
        shop_id: '',
        seller1_username: '',
        seller2_username: '',
        metadata: {},
        note: '',
        status: 'active'
      }
    });
  }

  handleEtsyInfoPackClick = (refEtsyInfoPackMid) => {
    if (refEtsyInfoPackMid) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-etsy/etsy-info-pack-detail/${refEtsyInfoPackMid}`,
        iframeTitle: `Info Pack Detail - ${refEtsyInfoPackMid}`
      });
    }
  }

  handleTrustedStoryClick = (shop) => {
    if (shop && shop.trusted_story_info) {
      this.setState({
        showTrustedStoryModal: true,
        selectedTrustedStoryData: shop.trusted_story_info,
        selectedShopForTrustedStory: shop
      });
    }
  }

  handleCloseIframeModal = () => {
    this.setState({
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    });
  }

  handleCloseTrustedStoryModal = () => {
    this.setState({
      showTrustedStoryModal: false,
      selectedTrustedStoryData: null,
      selectedShopForTrustedStory: null
    });
  }

  // Note modal handlers
  handleNoteClick = (shop) => {
    this.setState({
      showNoteModal: true,
      selectedNoteData: {
        MID: shop.MID,
        shop_id: shop.shop_id,
        seller1_username: shop.seller1_username,
        note: shop.note
      }
    });
  }

  handleCloseNoteModal = () => {
    this.setState({
      showNoteModal: false,
      selectedNoteData: null
    });
  }

  // Helper function to truncate note text
  truncateNote = (note, maxLength = 50) => {
    if (!note || note.length <= maxLength) {
      return note;
    }
    return note.substring(0, maxLength) + '...';
  }

  handleCreateInputChange = (field, value) => {
    this.setState({
      createFormData: {
        ...this.state.createFormData,
        [field]: value
      }
    });
  }

  handleEditInputChange = (field, value) => {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [field]: value
      }
    });
  }

  handleCreateShop = async () => {
    const { createFormData } = this.state;
    
    // Validation - shop_id is now optional
    // if (!createFormData.shop_id) {
    //   alert('Vui lòng nhập Shop ID');
    //   return;
    // }

    try {
      // Call create action
      await this.props.createTKT1RegisteredEtsyShop(createFormData);
      
      // Close modal
      this.handleCloseCreateModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1RegisteredEtsyShops(apiQuery);
      
      alert('Tạo registered etsy shop mới thành công!');
    } catch (error) {
      console.error('Error creating shop:', error);
      alert('Lỗi khi tạo registered etsy shop mới. Vui lòng thử lại.');
    }
  }

  handleSaveEdit = async () => {
    const { selectedShop, editFormData } = this.state;
    
    if (!selectedShop || !selectedShop._id) {
      alert('Không tìm thấy thông tin Shop để cập nhật');
      return;
    }

    try {
      // Call update action
      await this.props.updateTKT1RegisteredEtsyShop(selectedShop._id, editFormData);
      
      // Close modal
      this.handleCloseEditModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1RegisteredEtsyShops(apiQuery);
      
      alert('Cập nhật thông tin Shop thành công!');
    } catch (error) {
      console.error('Error updating shop:', error);
      alert('Lỗi khi cập nhật thông tin Shop. Vui lòng thử lại.');
    }
  }

  // Delete shop handlers
  handleDeleteClick = (shop) => {
    this.setState({
      showDeleteModal: true,
      selectedShop: shop
    });
  }

  handleCloseDeleteModal = () => {
    this.setState({
      showDeleteModal: false,
      selectedShop: null
    });
  }

  handleConfirmDelete = async () => {
    const { selectedShop } = this.state;
    
    if (!selectedShop || !selectedShop._id) {
      alert('Không tìm thấy thông tin Shop để xóa');
      return;
    }

    try {
      // Call delete action
      await this.props.deleteTKT1RegisteredEtsyShop(selectedShop._id);
      
      // Close modal
      this.handleCloseDeleteModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1RegisteredEtsyShops(apiQuery);
      
      alert('Xóa Shop thành công!');
    } catch (error) {
      console.error('Error deleting shop:', error);
      alert('Lỗi khi xóa Shop. Vui lòng thử lại.');
    }
  }

  // Helper function to prepare API query
  prepareApiQuery = (query) => {
    const { showColumns, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: query.search ? query.search.trim() : ''
    };
    
    // Add status filter if selected
    if (query.status && query.status.trim()) {
      apiQuery.status = query.status;
    }
    
    // Add other filters if selected
    if (query.ref_etsy_info_pack_mid && query.ref_etsy_info_pack_mid.trim()) {
      apiQuery.ref_etsy_info_pack_mid = query.ref_etsy_info_pack_mid;
    }
    
    if (query.trusted_story_mid && query.trusted_story_mid.trim()) {
      apiQuery.trusted_story_mid = query.trusted_story_mid;
    }
    
    if (query.shop_id && query.shop_id.trim()) {
      apiQuery.shop_id = query.shop_id;
    }
    
    if (query.seller1_username && query.seller1_username.trim()) {
      apiQuery.seller1_username = query.seller1_username;
    }
    
    if (query.seller2_username && query.seller2_username.trim()) {
      apiQuery.seller2_username = query.seller2_username;
    }
    
    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    // Save to localStorage
    localStorage.setItem('tkt1_registered_etsy_shop_query', JSON.stringify(trimmedQuery));
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1RegisteredEtsyShops(apiQuery);
    })
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery);
    this.props.getTKT1RegisteredEtsyShops(apiQuery);
    localStorage.setItem('tkt1_registered_etsy_shop_query', JSON.stringify(trimmedQuery));
  }

  updateUrl = (query) => {
    const { history } = this.props;
    // Remove showColumns from URL query - it's only for client display
    const { showColumns, ...urlQuery } = query;
    const queryStr = queryString.stringify(urlQuery);

    history.push({
      pathname: '/admin/tkt1-etsy/registered-shop',
      search: queryStr,
    });
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ shops: [] }, () => {
        this.updateUrl(trimmedQuery);
        this.props.getTKT1RegisteredEtsyShops(apiQuery);
        localStorage.setItem('tkt1_registered_etsy_shop_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="4">
          <InputGroup className="mb-3">
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo MID, Shop ID, Username..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={this.handleStatusChange}
            >
              <option value="">Tất cả</option>
              <option value="active">Hoạt động</option>
              <option value="inactive">Không hoạt động</option>
              <option value="suspended">Tạm dừng</option>
              <option value="deleted">Đã xóa</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp theo</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="MID">MID</option>
              <option value="shop_id">Shop ID</option>
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={this.handleSelectSortOrder}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderShopTable = () => {
    const { registeredEtsyShops } = this.props;
    const { showColumns, columnWidths } = this.state;
    
    // Ensure shops is an array and filter out any null/undefined items
    const safeShops = Array.isArray(registeredEtsyShops) ? registeredEtsyShops.filter(shop => shop != null && typeof shop === 'object') : [];
    
    // Early return if no data to prevent any rendering issues
    if (!safeShops || safeShops.length === 0) {
      return (
        <Table striped bordered hover style={{ tableLayout: 'auto' }}>
          <thead>
            <tr>
              <th style={{ width: `${columnWidths.stt}px`, position: 'relative' }}>
                STT
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'stt')}
                />
              </th>
              {showColumns.MID && <th style={{ width: `${columnWidths.MID}px`, position: 'relative' }}>
                MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'MID')}
                />
              </th>}
              {showColumns.shop_name && <th style={{ width: `${columnWidths.shop_name}px`, position: 'relative' }}>
                Shop Name
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'shop_name')}
                />
              </th>}
              {showColumns.trusted_story_mid && <th style={{ width: `${columnWidths.trusted_story_mid}px`, position: 'relative' }}>
                Story MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'trusted_story_mid')}
                />
              </th>}
              {showColumns.ref_etsy_info_pack_mid && <th style={{ width: `${columnWidths.ref_etsy_info_pack_mid}px`, position: 'relative' }}>
                Info Pack MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'ref_etsy_info_pack_mid')}
                />
              </th>}
              {showColumns.shop_id && <th style={{ width: `${columnWidths.shop_id}px`, position: 'relative' }}>
                Shop ID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'shop_id')}
                />
              </th>}
              {showColumns.seller1_username && <th style={{ width: `${columnWidths.seller1_username}px`, position: 'relative' }}>
                Seller Chính
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'seller1_username')}
                />
              </th>}
              {showColumns.seller2_username && <th style={{ width: `${columnWidths.seller2_username}px`, position: 'relative' }}>
                Seller Phụ
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'seller2_username')}
                />
              </th>}
              {showColumns.buyer_registration_date && <th style={{ width: `${columnWidths.buyer_registration_date}px`, position: 'relative' }}>
                ĐK Buyer
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'buyer_registration_date')}
                />
              </th>}
              {showColumns.seller_registration_date && <th style={{ width: `${columnWidths.seller_registration_date}px`, position: 'relative' }}>
                ĐK Seller
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'seller_registration_date')}
                />
              </th>}
              {showColumns.status && <th style={{ width: `${columnWidths.status}px`, position: 'relative' }}>
                Trạng thái
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'status')}
                />
              </th>}
              {showColumns.created_at && <th style={{ width: `${columnWidths.created_at}px`, position: 'relative' }}>
                Ngày tạo
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'created_at')}
                />
              </th>}
              {showColumns.updated_at && <th style={{ width: `${columnWidths.updated_at}px`, position: 'relative' }}>
                Ngày cập nhật
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'updated_at')}
                />
              </th>}
              {showColumns.note && <th style={{ width: `${columnWidths.note}px`, position: 'relative' }}>
                Ghi chú
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'note')}
                />
              </th>}
              <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover style={{ tableLayout: 'auto' }}>
        <thead>
          <tr>
            <th style={{ width: `${columnWidths.stt}px`, position: 'relative' }}>
              STT
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'stt')}
              />
            </th>
            {showColumns.MID && <th style={{ width: `${columnWidths.MID}px`, position: 'relative' }}>
              MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'MID')}
              />
            </th>}
            {showColumns.shop_name && <th style={{ width: `${columnWidths.shop_name}px`, position: 'relative' }}>
              Shop Name
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'shop_name')}
              />
            </th>}
            {showColumns.trusted_story_mid && <th style={{ width: `${columnWidths.trusted_story_mid}px`, position: 'relative' }}>
              Story MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'trusted_story_mid')}
              />
            </th>}
            {showColumns.ref_etsy_info_pack_mid && <th style={{ width: `${columnWidths.ref_etsy_info_pack_mid}px`, position: 'relative' }}>
              Info Pack MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'ref_etsy_info_pack_mid')}
              />
            </th>}
            {showColumns.shop_id && <th style={{ width: `${columnWidths.shop_id}px`, position: 'relative' }}>
              Shop ID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'shop_id')}
              />
            </th>}
            {showColumns.seller1_username && <th style={{ width: `${columnWidths.seller1_username}px`, position: 'relative' }}>
              Seller Chính
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'seller1_username')}
              />
            </th>}
            {showColumns.seller2_username && <th style={{ width: `${columnWidths.seller2_username}px`, position: 'relative' }}>
              Seller Phụ
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'seller2_username')}
              />
            </th>}
            {showColumns.buyer_registration_date && <th style={{ width: `${columnWidths.buyer_registration_date}px`, position: 'relative' }}>
              ĐK Buyer
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'buyer_registration_date')}
              />
            </th>}
            {showColumns.seller_registration_date && <th style={{ width: `${columnWidths.seller_registration_date}px`, position: 'relative' }}>
              ĐK Seller
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'seller_registration_date')}
              />
            </th>}
            {showColumns.status && <th style={{ width: `${columnWidths.status}px`, position: 'relative' }}>
              Trạng thái
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'status')}
              />
            </th>}
            {showColumns.created_at && <th style={{ width: `${columnWidths.created_at}px`, position: 'relative' }}>
              Ngày tạo
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'created_at')}
              />
            </th>}
            {showColumns.updated_at && <th style={{ width: `${columnWidths.updated_at}px`, position: 'relative' }}>
              Ngày cập nhật
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'updated_at')}
              />
            </th>}
            {showColumns.note && <th style={{ width: `${columnWidths.note}px`, position: 'relative' }}>
              Ghi chú
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'note')}
              />
            </th>}
            <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeShops.map((shop, index) => {
            if (!shop || typeof shop !== 'object') return null;
              
              return (
                <tr key={shop._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.MID && (
                    <td>
                      {shop.MID ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{shop.MID}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(shop.MID)}
                            title="Copy MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.shop_name && (
                    <td>
                      {shop.trusted_story_info?.etsy_shop_name ? (
                        <div className="d-flex align-items-center gap-2">
                          <span className="fw-bold text-primary">
                            {shop.trusted_story_info.etsy_shop_name}
                          </span>
                          <FaExternalLinkAlt 
                            size={12} 
                            style={{ 
                              cursor: 'pointer', 
                              color: '#007bff'
                            }}
                            title="Mở shop Etsy trong tab mới"
                            onClick={() => window.open(`https://www.etsy.com/shop/${shop.trusted_story_info.etsy_shop_name}`, '_blank')}
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.trusted_story_mid && (
                    <td>
                      {shop.trusted_story_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="success" 
                            style={{ 
                              fontSize: '0.9em', 
                              padding: '6px 10px',
                              cursor: 'pointer'
                            }}
                            onClick={() => this.handleTrustedStoryClick(shop)}
                            title="Click để xem chi tiết Story"
                          >
                            {shop.trusted_story_mid}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(shop.trusted_story_mid)}
                            title="Copy Story MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.ref_etsy_info_pack_mid && (
                    <td>
                      {shop.ref_etsy_info_pack_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="primary" 
                            style={{ 
                              fontSize: '0.9em', 
                              padding: '6px 10px',
                              cursor: 'pointer'
                            }}
                            onClick={() => this.handleEtsyInfoPackClick(shop.ref_etsy_info_pack_mid)}
                            title="Click để xem chi tiết Info Pack"
                          >
                            {shop.ref_etsy_info_pack_mid}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(shop.ref_etsy_info_pack_mid)}
                            title="Copy Info Pack MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.shop_id && (
                    <td>
                      {shop.shop_id ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{shop.shop_id}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(shop.shop_id)}
                            title="Copy Shop ID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.seller1_username && (
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span>{shop.seller1_username || '-'}</span>
                        {shop.seller1_username && (
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(shop.seller1_username)}
                            title="Copy Seller Chính"
                          />
                        )}
                      </div>
                    </td>
                  )}
                  {showColumns.seller2_username && (
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span>{shop.seller2_username || '-'}</span>
                        {shop.seller2_username && (
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(shop.seller2_username)}
                            title="Copy Seller Phụ"
                          />
                        )}
                      </div>
                    </td>
                  )}
                  {showColumns.buyer_registration_date && (
                    <td>
                      {shop.etsy_info_pack_info?.buyer_registration_date ? (
                        <Badge bg="info" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                          {new Date(shop.etsy_info_pack_info.buyer_registration_date).toLocaleDateString('vi-VN')}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.seller_registration_date && (
                    <td>
                      {shop.etsy_info_pack_info?.seller_registration_date ? (
                        <Badge bg="success" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                          {new Date(shop.etsy_info_pack_info.seller_registration_date).toLocaleDateString('vi-VN')}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.status && (
                    <td>
                      {shop.status ? (
                        <Badge 
                          bg={
                            shop.status === 'active' ? 'success' :
                            shop.status === 'inactive' ? 'warning' :
                            shop.status === 'suspended' ? 'info' :
                            shop.status === 'deleted' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(shop.status)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.created_at && (
                    <td>
                      {shop.created_at ? 
                        new Date(shop.created_at).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </td>
                  )}
                  {showColumns.updated_at && (
                    <td>
                      {shop.updated_at ? 
                        new Date(shop.updated_at).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </td>
                  )}
                  {showColumns.note && (
                    <td>
                      {shop.note ? (
                        <div className="d-flex align-items-center gap-2">
                          <span 
                            style={{ 
                              whiteSpace: 'nowrap',
                              cursor: shop.note.length > 100 ? 'pointer' : 'default'
                            }}
                            title={shop.note}
                          >
                            {this.truncateNote(shop.note)}
                          </span>
                          {shop.note.length > 100 && (
                            <FaStickyNote 
                              size={12} 
                              style={{ 
                                cursor: 'pointer', 
                                color: '#6c757d',
                                flexShrink: 0
                              }}
                              onClick={() => this.handleNoteClick(shop)}
                              title="Xem đầy đủ ghi chú"
                            />
                          )}
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(shop)}
                      />
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(shop)}
                      />
                      <FaTrash 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#dc3545'
                        }}
                        title="Xóa shop"
                        onClick={() => this.handleDeleteClick(shop)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    const { columnWidths } = this.state;
    
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Registered Etsy Shop - Danh sách tất cả
              </h2>
            </Col>
            <Col className="text-end">
              <Button 
                variant="success" 
                onClick={() => this.setState({ showCreateModal: true })}
                className="me-2"
              >
                <i className="fas fa-plus me-1"></i>
                Thêm Shop mới
              </Button>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="sticky-table">
              {this.renderShopTable()}
              </div>
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                    MID: 'MID',
                    ref_etsy_info_pack_mid: 'Info Pack MID',
                    trusted_story_mid: 'Story MID',
                    shop_name: 'Shop Name',
                    shop_id: 'Shop ID',
                    seller1_username: 'Seller Chính',
                    seller2_username: 'Seller Phụ',
                    buyer_registration_date: 'ĐK Buyer',
                    seller_registration_date: 'ĐK Seller',
                    status: 'Trạng thái',
                    created_at: 'Ngày tạo',
                    updated_at: 'Ngày cập nhật',
                    note: 'Ghi chú'
                  };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin Registered Etsy Shop</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedShop && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedShop.MID}
                      </Badge>
                      {this.state.selectedShop.MID && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedShop.MID)}
                          title="Copy MID"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Shop ID:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedShop.shop_id}
                      </Badge>
                      {this.state.selectedShop.shop_id && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedShop.shop_id)}
                          title="Copy Shop ID"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                
                {/* Reference Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin tham chiếu</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Info Pack MID:</strong> 
                    <div className="mt-1">
                      {this.state.selectedShop.ref_etsy_info_pack_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="primary" 
                            style={{ 
                              fontSize: '0.9em', 
                              padding: '6px 10px',
                              cursor: 'pointer'
                            }}
                            onClick={() => this.handleEtsyInfoPackClick(this.state.selectedShop.ref_etsy_info_pack_mid)}
                            title="Click để xem chi tiết Info Pack"
                          >
                            {this.state.selectedShop.ref_etsy_info_pack_mid}
                          </Badge>
                          <FaCopy 
                            size={14} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedShop.ref_etsy_info_pack_mid)}
                            title="Copy Info Pack MID"
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Story MID:</strong> 
                    <div className="mt-1">
                      {this.state.selectedShop.trusted_story_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="success" 
                            style={{ 
                              fontSize: '0.9em', 
                              padding: '6px 10px',
                              cursor: 'pointer'
                            }}
                            onClick={() => this.handleTrustedStoryClick(this.state.selectedShop.trusted_story_mid)}
                            title="Click để xem chi tiết Story"
                          >
                            {this.state.selectedShop.trusted_story_mid}
                          </Badge>
                          <FaCopy 
                            size={14} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedShop.trusted_story_mid)}
                            title="Copy Story MID"
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Shop Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin shop</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Shop Name:</strong> 
                    <div className="mt-1">
                      {this.state.selectedShop.trusted_story_info?.etsy_shop_name ? (
                        <div className="d-flex align-items-center gap-2">
                          <span className="fw-bold text-primary">
                            {this.state.selectedShop.trusted_story_info.etsy_shop_name}
                          </span>
                          <FaExternalLinkAlt 
                            size={14} 
                            style={{ 
                              cursor: 'pointer', 
                              color: '#007bff'
                            }}
                            title="Mở shop Etsy trong tab mới"
                            onClick={() => window.open(`https://www.etsy.com/shop/${this.state.selectedShop.trusted_story_info.etsy_shop_name}`, '_blank')}
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Shop ID:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedShop.shop_id}
                      </Badge>
                      {this.state.selectedShop.shop_id && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedShop.shop_id)}
                          title="Copy Shop ID"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                
                {/* Seller Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin người bán</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Seller Chính:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedShop.seller1_username || '-'}</span>
                      {this.state.selectedShop.seller1_username && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedShop.seller1_username)}
                          title="Copy Seller 1 Username"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Seller Phụ:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedShop.seller2_username || '-'}</span>
                      {this.state.selectedShop.seller2_username && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedShop.seller2_username)}
                          title="Copy Seller 2 Username"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                
                {/* Status Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Trạng thái</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      {this.state.selectedShop.status ? (
                        <Badge 
                          bg={
                            this.state.selectedShop.status === 'active' ? 'success' :
                            this.state.selectedShop.status === 'inactive' ? 'warning' :
                            this.state.selectedShop.status === 'suspended' ? 'info' :
                            this.state.selectedShop.status === 'deleted' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(this.state.selectedShop.status)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Date Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin ngày tháng</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày tạo:</strong> 
                    <div className="mt-1">
                      {this.state.selectedShop.created_at ? 
                        new Date(this.state.selectedShop.created_at).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày cập nhật:</strong> 
                    <div className="mt-1">
                      {this.state.selectedShop.updated_at ? 
                        new Date(this.state.selectedShop.updated_at).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
                
                {/* Additional Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin bổ sung</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedShop.note || '-'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Create Modal */}
        <Modal show={this.state.showCreateModal} onHide={this.handleCloseCreateModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thêm Registered Etsy Shop mới</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Shop ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.shop_id}
                      onChange={(e) => this.handleCreateInputChange('shop_id', e.target.value)}
                      placeholder="Nhập Shop ID (tùy chọn)"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Info Pack MID</Form.Label>
                    <Select
                      value={this.getEtsyInfoPackOptions().find(option => option.value === this.state.createFormData.ref_etsy_info_pack_mid) || null}
                      onChange={(selectedOption) => this.handleCreateInputChange('ref_etsy_info_pack_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getEtsyInfoPackOptions()}
                      placeholder="Chọn Info Pack..."
                      isSearchable
                      isClearable
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Story MID</Form.Label>
                    <Select
                      value={this.getTrustedStoryOptions().find(option => option.value === this.state.createFormData.trusted_story_mid) || null}
                      onChange={(selectedOption) => this.handleCreateInputChange('trusted_story_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getTrustedStoryOptions()}
                      placeholder="Chọn Story..."
                      isSearchable
                      isClearable
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.createFormData.status}
                      onChange={(e) => this.handleCreateInputChange('status', e.target.value)}
                    >
                      <option value="active">Hoạt động</option>
                      <option value="inactive">Không hoạt động</option>
                      <option value="suspended">Tạm dừng</option>
                      <option value="deleted">Đã xóa</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Seller Chính</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.seller1_username}
                      onChange={(e) => this.handleCreateInputChange('seller1_username', e.target.value)}
                      placeholder="Nhập Seller Chính"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Seller Phụ</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.seller2_username}
                      onChange={(e) => this.handleCreateInputChange('seller2_username', e.target.value)}
                      placeholder="Nhập Seller Phụ"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.createFormData.note}
                      onChange={(e) => this.handleCreateInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseCreateModal}>
              Hủy
            </Button>
            <Button variant="success" onClick={this.handleCreateShop}>
              <i className="fas fa-plus me-1"></i>
              Tạo Shop mới
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa Registered Etsy Shop</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Shop ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.shop_id}
                      onChange={(e) => this.handleEditInputChange('shop_id', e.target.value)}
                      placeholder="Nhập Shop ID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Info Pack MID</Form.Label>
                    <Select
                      value={this.getEtsyInfoPackOptions().find(option => option.value === this.state.editFormData.ref_etsy_info_pack_mid) || null}
                      onChange={(selectedOption) => this.handleEditInputChange('ref_etsy_info_pack_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getEtsyInfoPackOptions()}
                      placeholder="Chọn Info Pack..."
                      isSearchable
                      isClearable
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Story MID</Form.Label>
                    <Select
                      value={this.getTrustedStoryOptions().find(option => option.value === this.state.editFormData.trusted_story_mid) || null}
                      onChange={(selectedOption) => this.handleEditInputChange('trusted_story_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getTrustedStoryOptions()}
                      placeholder="Chọn Story..."
                      isSearchable
                      isClearable
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                    >
                      <option value="active">Hoạt động</option>
                      <option value="inactive">Không hoạt động</option>
                      <option value="suspended">Tạm dừng</option>
                      <option value="deleted">Đã xóa</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Seller Chính</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.seller1_username}
                      onChange={(e) => this.handleEditInputChange('seller1_username', e.target.value)}
                      placeholder="Nhập Seller Chính"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Seller Phụ</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.seller2_username}
                      onChange={(e) => this.handleEditInputChange('seller2_username', e.target.value)}
                      placeholder="Nhập Seller Phụ"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleEditInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveEdit}>
              Lưu thay đổi
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={this.handleCloseIframeModal}
          url={this.state.iframeUrl}
          title={this.state.iframeTitle}
          showSidebar={false}
        />

        {/* Note Modal */}
        <Modal show={this.state.showNoteModal} onHide={this.handleCloseNoteModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Ghi chú chi tiết</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedNoteData && (
              <div>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedNoteData.MID}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Shop ID:</strong> 
                    <div className="mt-1">
                      <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedNoteData.shop_id}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Seller Chính:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNoteData.seller1_username || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-2 p-3 bg-light rounded" style={{ 
                      whiteSpace: 'pre-wrap',
                      maxHeight: '400px',
                      overflowY: 'auto',
                      border: '1px solid #dee2e6'
                    }}>
                      {this.state.selectedNoteData.note || 'Không có ghi chú'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseNoteModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal show={this.state.showDeleteModal} onHide={this.handleCloseDeleteModal}>
          <Modal.Header closeButton>
            <Modal.Title>Xác nhận xóa Registered Etsy Shop</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedShop && (
              <div>
                <p>Bạn có chắc chắn muốn xóa shop này không?</p>
                <div className="alert alert-warning" role="alert">
                  <strong>MID:</strong> {this.state.selectedShop.MID}<br/>
                  <strong>Shop ID:</strong> {this.state.selectedShop.shop_id || 'N/A'}<br/>
                  <strong>Seller Chính:</strong> {this.state.selectedShop.seller1_username || 'N/A'}
                </div>
                <p className="text-danger">
                  <strong>Cảnh báo:</strong> Hành động này không thể hoàn tác!
                </p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseDeleteModal}>
              Hủy
            </Button>
            <Button variant="danger" onClick={this.handleConfirmDelete}>
              <FaTrash size={14} className="me-1" />
              Xóa Shop
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Trusted Story Modal */}
        <Modal show={this.state.showTrustedStoryModal} onHide={this.handleCloseTrustedStoryModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin Story</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedTrustedStoryData && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedTrustedStoryData.MID}
                      </Badge>
                      {this.state.selectedTrustedStoryData.MID && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedTrustedStoryData.MID)}
                          title="Copy MID"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Type:</strong> 
                    <div className="mt-1">
                      <Badge 
                        bg={
                          this.state.selectedTrustedStoryData.type === 'FICTION' ? 'primary' :
                          this.state.selectedTrustedStoryData.type === 'REAL' ? 'success' :
                          'secondary'
                        }
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {this.state.selectedTrustedStoryData.type || 'N/A'}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                
                {/* Artist Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin Artist</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Artist Name:</strong> 
                    <div className="mt-1">
                      <span className="fw-bold text-primary">
                        {this.state.selectedTrustedStoryData.artist_name || '-'}
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Artist Story:</strong> 
                    <div className="mt-1 p-3 bg-light rounded" style={{ 
                      whiteSpace: 'pre-wrap',
                      maxHeight: '200px',
                      overflowY: 'auto',
                      border: '1px solid #dee2e6'
                    }}>
                      {this.state.selectedTrustedStoryData.artist_story || 'Không có thông tin'}
                    </div>
                  </Col>
                </Row>
                
                {/* Shop Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin Shop</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Etsy Shop Name:</strong> 
                    <div className="mt-1">
                      {this.state.selectedTrustedStoryData.etsy_shop_name ? (
                        <div className="d-flex align-items-center gap-2">
                          <span className="fw-bold text-success">
                            {this.state.selectedTrustedStoryData.etsy_shop_name}
                          </span>
                          <FaExternalLinkAlt 
                            size={14} 
                            style={{ 
                              cursor: 'pointer', 
                              color: '#007bff'
                            }}
                            title="Mở shop Etsy trong tab mới"
                            onClick={() => window.open(`https://www.etsy.com/shop/${this.state.selectedTrustedStoryData.etsy_shop_name}`, '_blank')}
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Etsy Shop Story:</strong> 
                    <div className="mt-1 p-3 bg-light rounded" style={{ 
                      whiteSpace: 'pre-wrap',
                      maxHeight: '200px',
                      overflowY: 'auto',
                      border: '1px solid #dee2e6'
                    }}>
                      {this.state.selectedTrustedStoryData.etsy_shop_story || 'Không có thông tin'}
                    </div>
                  </Col>
                </Row>
                
                {/* Status Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Trạng thái</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Status:</strong> 
                    <div className="mt-1">
                      <Badge 
                        bg={
                          this.state.selectedTrustedStoryData.status === 'active' ? 'success' :
                          this.state.selectedTrustedStoryData.status === 'draft' ? 'warning' :
                          this.state.selectedTrustedStoryData.status === 'inactive' ? 'danger' :
                          'secondary'
                        }
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {this.state.selectedTrustedStoryData.status || 'N/A'}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Is Active:</strong> 
                    <div className="mt-1">
                      <Badge 
                        bg={this.state.selectedTrustedStoryData.is_active ? 'success' : 'danger'}
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {this.state.selectedTrustedStoryData.is_active ? 'Active' : 'Inactive'}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                
                {/* Date Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin ngày tháng</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Created At:</strong> 
                    <div className="mt-1">
                      {this.state.selectedTrustedStoryData.created_at ? 
                        new Date(this.state.selectedTrustedStoryData.created_at).toLocaleString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Updated At:</strong> 
                    <div className="mt-1">
                      {this.state.selectedTrustedStoryData.updated_at ? 
                        new Date(this.state.selectedTrustedStoryData.updated_at).toLocaleString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
                
                {/* Registration Dates from Etsy Info Pack */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin đăng ký từ Etsy Info Pack</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <small className="text-muted">
                      Debug: {this.state.selectedShopForTrustedStory ? 'Shop data available' : 'No shop data'} | 
                      Pack info: {this.state.selectedShopForTrustedStory?.etsy_info_pack_info ? 'Available' : 'Not available'}
                    </small>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Buyer Registration Date:</strong> 
                    <div className="mt-1">
                      {this.state.selectedShopForTrustedStory?.etsy_info_pack_info?.buyer_registration_date ? 
                        <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                          {new Date(this.state.selectedShopForTrustedStory.etsy_info_pack_info.buyer_registration_date).toLocaleDateString('vi-VN')}
                        </Badge> : 
                        <span className="text-muted">Không có dữ liệu</span>
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Seller Registration Date:</strong> 
                    <div className="mt-1">
                      {this.state.selectedShopForTrustedStory?.etsy_info_pack_info?.seller_registration_date ? 
                        <Badge bg="success" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                          {new Date(this.state.selectedShopForTrustedStory.etsy_info_pack_info.seller_registration_date).toLocaleDateString('vi-VN')}
                        </Badge> : 
                        <span className="text-muted">Không có dữ liệu</span>
                      }
                    </div>
                  </Col>
                </Row>
                
                {/* Additional Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin bổ sung</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Note:</strong> 
                    <div className="mt-1 p-3 bg-light rounded" style={{ 
                      whiteSpace: 'pre-wrap',
                      maxHeight: '200px',
                      overflowY: 'auto',
                      border: '1px solid #dee2e6'
                    }}>
                      {this.state.selectedTrustedStoryData.note || 'Không có ghi chú'}
                    </div>
                  </Col>
                </Row>
                
                {/* Arrays Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin mảng dữ liệu</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Artist Avatars:</strong> 
                    <div className="mt-1">
                      {this.state.selectedTrustedStoryData.artist_avatars && this.state.selectedTrustedStoryData.artist_avatars.length > 0 ? 
                        <span className="text-success">Có {this.state.selectedTrustedStoryData.artist_avatars.length} ảnh</span> :
                        <span className="text-muted">Không có ảnh</span>
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Shop Logos:</strong> 
                    <div className="mt-1">
                      {this.state.selectedTrustedStoryData.shop_logos && this.state.selectedTrustedStoryData.shop_logos.length > 0 ? 
                        <span className="text-success">Có {this.state.selectedTrustedStoryData.shop_logos.length} logo</span> :
                        <span className="text-muted">Không có logo</span>
                      }
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Team Story:</strong> 
                    <div className="mt-1">
                      {this.state.selectedTrustedStoryData.team_story && this.state.selectedTrustedStoryData.team_story.length > 0 ? 
                        <span className="text-success">Có {this.state.selectedTrustedStoryData.team_story.length} team story</span> :
                        <span className="text-muted">Không có team story</span>
                      }
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseTrustedStoryModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    registeredEtsyShops: state.tkt1RegisteredEtsyShopReducer.registeredEtsyShops,
    totalCount: state.tkt1RegisteredEtsyShopReducer.totalCount,
    etsyInfoPacks: state.tkt1EtsyInfoPackReducer?.etsyInfoPacks || [],
    trustedStories: state.tkt1TrustedStoryReducer?.trustedStories || []
  };
};

export default connect(mapStateToProps, { getTKT1RegisteredEtsyShops, createTKT1RegisteredEtsyShop, updateTKT1RegisteredEtsyShop, deleteTKT1RegisteredEtsyShop, getTKT1EtsyInfoPacks, getTKT1TrustedStories })(TKT1RegisteredEtsyShop);
